import { IGatsbyImageData, Layout, withArtDirection } from "gatsby-plugin-image";

export const emptyImage = {
  layout: "constrained" as Layout,
  placeholder: {
    fallback: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8/5+hHgAHggJ/PchI7wAAAABJRU5ErkJggg==",
  },
  images: {
    fallback: {
      src: "",
      srcSet: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8/5+hHgAHggJ/PchI7wAAAABJRU5ErkJggg==",
      sizes: "(min-width: 1px) 1px, 100vw",
    },
    sources: [],
  },
  width: 1,
  height: 1,
};

export const useHideImage = (image: IGatsbyImageData, mediaQueryHide = "(max-width: 480px)") =>
  withArtDirection(image, [
    {
      media: mediaQueryHide,
      image: emptyImage,
    },
  ]);
